import { useEffect, useCallback } from 'react';

interface IProps {
  setTitle: (title: string) => void;
  title: string;
  titleRef: any;
}

const useTitlePosition = ({ setTitle, title, titleRef }: IProps) => {
  const getTitlePosition = useCallback(() => {
    const posTitle = titleRef?.current?.getBoundingClientRect();

    if (posTitle && posTitle.top <= 600 && posTitle.top > 100) {
      setTitle(title);
    }
  }, [setTitle, title, titleRef]);

  useEffect(() => {
    window.addEventListener('scroll', getTitlePosition);

    return () => window.removeEventListener('scroll', getTitlePosition);
  }, [getTitlePosition]);
};

export default useTitlePosition;
